import * as React from 'react';
import cn from 'clsx';

import { IWithDeviceTypeProps, withDeviceType } from '../../../../utils/withDeviceType';
import { TypedRadioButton } from '../../../../components/TypedRadioButton';

import * as styles from './styles.css';

interface IDealPriceRadioGroupProps extends IWithDeviceTypeProps {
  handleChange(key: string, index: number): void;
  groupName: string;
  selectedItemIndex: number;
  list: { chipName: string }[];
}

function DealPriceRadioGroup(props: IDealPriceRadioGroupProps) {
  const { deviceType, groupName, list, selectedItemIndex, handleChange } = props;

  return (
    <div className={cn(styles['radio-group'], styles[deviceType])}>
      {list.map((item, index) => (
        <TypedRadioButton
          key={item.chipName}
          theme="transparent_light"
          name={groupName}
          value={index}
          checked={index === selectedItemIndex}
          label={item.chipName}
          onChange={() => handleChange(groupName, index)}
        />
      ))}
    </div>
  );
}

const DealPriceRadioGroupWithDeviceType = withDeviceType<IDealPriceRadioGroupProps>(DealPriceRadioGroup);
export { DealPriceRadioGroupWithDeviceType as DealPriceRadioGroup };
